export default [
    {
      text: 'Name',
      value: 'name',
      order: 0,
      sortable: true,
      hidable: false,
      hidden: false,
    },

    {
        text: 'Color',
        value: 'color',
        order: 0,
        sortable: true,
        hidable: false,
        hidden: false,
      },
      
  
    {
      text: 'Actions',
      value: 'actions',
      align: 'right',
      sortable: false,
      order: 1,
      hidable: true,
      hidden: false,
      width: '92px',
    },
  ];
  